module.exports = __webpack_public_path__ + "img/bitvavo-logo.9797ffc3.png";